const trueBlankDayTypeRequest = {
    dayTypeCode: '',
    fromDate:'',
    toDate: '',
    fromTime:'',
    toTime: '',
    status: 'U',
    myComment: '',
    statusComment: '',
  };
  
  export default trueBlankDayTypeRequest;


// WEBPACK FOOTER //
// ./src/Components/DayType/utils/day-type-requests/trueBlankDayTypeRequest.js